export default {
  "hero.title": "OOPBUY Spreadsheet",
  "hero.subtitle": "Der smarteste Weg, weltweit einzukaufen. Entdecke exklusive Deals, vergleiche Preise und spare mit dem OOPBUY Spreadsheet.",
  "hero.cta": "Jetzt entdecken",
  "hero.cta_secondary": "oopbuy spreadsheet",
  "categories.title_small": "Produktkategorien",
  "categories.title_line1": "Entdecke",
  "categories.title_line2": "deine Styles",
  "categories.all": "Alle Kategorien",
  "features.title": "Warum OOPBUY Spreadsheet?",
  "features.subtitle": "Deine All-in-One Lösung für internationales Shopping. Vergleiche, prüfe und spare – alles an einem Ort.",
  "features.price_title": "Preisvergleich",
  "features.price_desc": "Vergleiche tausende Produkte in Echtzeit und finde garantiert den besten Preis für deine Lieblingsartikel.",
  "features.qc_title": "QC-Kontrolle",
  "features.qc_desc": "Jedes Produkt durchläuft eine strenge Qualitätskontrolle. Wir prüfen Nähte, Material und Verarbeitung bevor es zu dir kommt.",
  "features.shipping_title": "Weltweiter Versand",
  "features.shipping_desc": "Schnelle und sichere Lieferung nach Deutschland, Österreich und in die Schweiz. Mit Tracking von Abholung bis Zustellung.",
  "reviews.title": "Das sagen unsere Nutzer",
  "reviews.text": "Das OOPBUY Spreadsheet hat meine Art einzukaufen komplett verändert. Ich spare nicht nur Geld, sondern auch unglaublich viel Zeit bei der Recherche. Die Preisvergleiche sind extrem präzise und die QC-Berichte geben mir absolute Sicherheit bei jedem Kauf.",
  "reviews.name": "Markus Lehmann",
  "reviews.role": "Stammkunde aus Berlin",
  "reviews.cta": "Jetzt entdecken",
  "seo.section_tag": "OOPBUY Spreadsheet Ratgeber",
  "seo.title": "OOPBUY Spreadsheet",
  "seo.subtitle": "Unsere Experten-Guides für smartes Shopping",
  "seo.view_all": "Alle Artikel ansehen",
  "cta.title": "Bereit für dein OOPBUY Spreadsheet?",
  "cta.subtitle": "Starte noch heute und entdecke eine völlig neue Art des Online-Shoppings.",
  "cta.button": "Buy it now",
};